import type { SxProps, Theme } from "@mui/material";

export const formStyle: SxProps = (theme: Theme) => ({
  background: theme.palette.box1.main,
  borderRadius: 2,
  boxShadow: 1,
  color: theme.palette.box1.contrastText,
  p: 2,
  mb: 4,

  "& .MuiOutlinedInput-root": {
    width: "380px",
  },
});

export const formRowStyle: SxProps = () => ({
  mb: 4,
});

export const multiSelectorStyle: SxProps = {
  mb: 4,
};

export const multiSelectorRow: SxProps = {
  minWidth: 300,
  boxShadow: 0,
  border: 1,
  borderColor: "rgba(0, 0, 0, 0.23)",

  "& .MuiListItemText-secondary": {
    opacity: 0.6,
    fontWeight: 600,
  },
};

export const multiSelectorPicker: SxProps = {
  height: 400,
  overflow: "auto",
};
